import { IconComponent } from 'models/icons';

/**
 * This file was auto-generated using svgr
 *
 * Source file: assets/icons/metavrse-logo.svg
 */
const IconMetavrseLogo: IconComponent = ({
  size = 24,
  color = 'white',
  className,
  svgElementProps: props = {},
}) => (
  <svg
    style={{ zIndex: '10000' }}
    width={size}
    height={size}
    viewBox="0 0 32 32"
    fill="#ffffff"
    xmlns="http://www.w3.org/2000/svg"
    color={color}
    className={className}
    {...props}
  >
    <style type="text/css">
      {
        "\n    .st0{clip-path:url(#SVGID_1_);}\n\t.st1{clip-path:url(#SVGID_2_);}\n\t.st2{clip-path:url(#SVGID_3_);}\n\t.st3{fill:#FFFFFF;}\n\t.st4{opacity:0.7;}\n\t.st5{clip-path:url(#SVGID_4_);}\n\t.st6{clip-path:url(#SVGID_5_);}\n\t.st7{fill:url(#SVGID_6_);}\n\t.st8{clip-path:url(#SVGID_7_);}\n  "
      }
    </style>
    <g>
      <defs>
        <rect id="SVGID_14_" x={1.7} y={1.7} width={29.3} height={28.8} />
      </defs>
      <clipPath id="SVGID_1_">
        <use
          xlinkHref="#SVGID_14_"
          style={{
            overflow: "visible",
          }}
        />
      </clipPath>
      <g className="st0">
        <g>
          <defs>
            <rect id="SVGID_16_" x={0.9} y={1} width={30.5} height={30.5} />
          </defs>
          <clipPath id="SVGID_2_">
            <use
              xlinkHref="#SVGID_16_"
              style={{
                overflow: "visible",
              }}
            />
          </clipPath>
          <g className="st1">
            <g>
              <defs>
                <rect id="SVGID_18_" x={0.9} y={1} width={30.5} height={30.5} />
              </defs>
              <clipPath id="SVGID_3_">
                <use
                  xlinkHref="#SVGID_18_"
                  style={{
                    overflow: "visible",
                  }}
                />
              </clipPath>
              <g className="st2">
                <path
                  className="st3"
                  d="M29.9,2.2c0,0-0.2,5.9-5.9,13.9c0-0.2,0.1-0.5,0.1-0.7c0-2.2-1.8-4-4-4s-4,1.8-4,4s1.8,4,4,4 c0,0,0.2,0,0.6-0.1c1-0.2,1.9-0.8,2.7-1.4c0.5-0.4,1-1,1.4-1.5c0.5-0.6,0.9-1.2,1.3-1.8c0.5-0.7,0.9-1.5,1.4-2.3 c0.5-0.9,0.9-1.9,1.3-2.8c0.5-1.1,0.8-2.2,1.2-3.3c0.4-1.3,0.7-2.5,0.9-3.8c0,0,0-0.1,0-0.1L29.9,2.2L29.9,2.2z"
                />
                <g className="st4">
                  <g>
                    <defs>
                      <rect
                        id="SVGID_20_"
                        x={1.7}
                        y={1.7}
                        width={16.7}
                        height={21.6}
                      />
                    </defs>
                    <clipPath id="SVGID_4_">
                      <use
                        xlinkHref="#SVGID_20_"
                        style={{
                          overflow: "visible",
                        }}
                      />
                    </clipPath>
                    <g className="st5">
                      <path
                        className="st3"
                        d="M4.4,14.2c0,0,1.2-2.1,5.9-5.8c0.2-1.3,1-4.9,5-6.1c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0.1,0,0.1,0 c0,0,0,0,0,0c0,0,0.1,0,0.1,0c0,0,0,0,0,0c0,0,0.1,0,0.1,0c0,0,0,0,0,0c0.1,0,0.1,0,0.2,0c0,0,0,0,0,0c0.1,0,0.1,0,0.2,0 c0,0,0,0,0,0c0.1,0,0.1,0,0.2,0c0,0,0,0,0,0c0,0,0.1,0,0.1,0c0,0,0,0,0.1,0c0,0,0.1,0,0.1,0c0,0,0,0,0.1,0c0,0,0.1,0,0.1,0 c0,0,0,0,0.1,0c0.1,0,0.1,0,0.2,0c0,0,0,0,0,0c0.1,0,0.1,0,0.2,0c0,0,0,0,0,0c0,0,0.1,0,0.1,0c0,0,0,0,0.1,0 c0,0,0.1,0,0.1,0c0,0,0,0,0.1,0c0,0,0.1,0,0.1,0c0,0,0,0,0.1,0c0,0,0.1,0,0.1,0c0,0,0,0,0.1,0c0.1,0,0.1,0,0.2,0 c0,0-0.1,0-0.1,0l0,0c-0.5-0.1-1.1-0.1-1.7-0.1C8.3,1.7,1.7,8.2,1.7,16.3c0,2.5,0.7,4.9,1.8,7C2.3,20.9,1.9,17.8,4.4,14.2"
                      />
                    </g>
                  </g>
                </g>
              </g>
            </g>
            <g>
              <defs>
                <path
                  id="SVGID_22_"
                  d="M29.1,16.7c-0.6,1.2-1.7,2.5-3.5,3.7c-0.7,0.5-1.5,0.8-2.2,1.1c-2.1,0.8-4,0.8-5.4,0.6 c-1.4-0.2-2.2-0.5-2.2-0.5s-0.3-0.1-0.8-0.3c-1.2-0.6-3.2-2-2.9-4.8c0,0.1,0,0.2-0.1,0.3c-0.3,1.5-0.5,3.1-0.4,4.7 c0.1,1.3,0.4,2.5,1.1,3.7c0.2,0.3,0.4,0.6,0.6,0.9c0.5,0.1,1.5,0.1,3.4,0.1c0.2,0,0.5,0,0.7,0c2.1,0,3.8,0,4.2,0 c0.1,0,0.1,0,0.1,0s1.7-0.1,1.2,1.2c0,0.1-0.1,0.2-0.2,0.3c-0.4,0.4-1.2,0.8-2.1,1.1c0.3,0,0.7-0.1,1.1-0.1 c1.1-0.2,2.5-0.6,3.6-1.2c1.9-1.7,3.4-3.9,4.2-6.4c0.5-1.4,0.7-3,0.7-4.6c0-1.2-0.2-3-0.4-3.4C29.9,13.1,30.1,14.7,29.1,16.7"
                />
              </defs>
              <clipPath id="SVGID_5_">
                <use
                  xlinkHref="#SVGID_22_"
                  style={{
                    overflow: "visible",
                  }}
                />
              </clipPath>
              <g className="st6">
                <g>
                  <linearGradient
                    id="SVGID_6_"
                    gradientUnits="userSpaceOnUse"
                    x1={-1021.5568}
                    y1={786.4097}
                    x2={-1021.5286}
                    y2={786.4097}
                    gradientTransform="matrix(659.6 0 0 659.6 673830.375 -518694.875)"
                  >
                    <stop
                      offset={0}
                      style={{
                        stopColor: "#FFFFFF",
                      }}
                    />
                    <stop
                      offset={0.46}
                      style={{
                        stopColor: "#FFFFFF",
                      }}
                    />
                    <stop
                      offset={1}
                      style={{
                        stopColor: "#FFFFFF",
                      }}
                    />
                  </linearGradient>
                  <rect
                    x={11.5}
                    y={13.1}
                    className="st7"
                    width={18.7}
                    height={15.8}
                  />
                </g>
              </g>
            </g>
            <g>
              <defs>
                <rect id="SVGID_25_" x={0.9} y={1} width={30.5} height={30.5} />
              </defs>
              <clipPath id="SVGID_7_">
                <use
                  xlinkHref="#SVGID_25_"
                  style={{
                    overflow: "visible",
                  }}
                />
              </clipPath>
              <g className="st8">
                <path
                  className="st3"
                  d="M19.7,28.9c-2.5,0.1-4.8-0.8-6.3-2.8c-0.2-0.3-0.4-0.6-0.6-0.9c-1.4-2.6-1.3-5.6-0.7-8.4 c0-0.1,0-0.2,0.1-0.3c1.1-4.6,6-7.7,6-7.7s2.2-1.3,3.5-1.8c0.7-0.3,1.7-0.8,2-1.6c0.3-0.8-0.1-1.6-0.7-2.1 c-1.2-1-3.2-1.5-4.9-1.7c0,0,0.1,0,0.1,0c-0.1,0-0.1,0-0.2,0c0,0,0,0-0.1,0c0,0-0.1,0-0.1,0c0,0,0,0-0.1,0c0,0-0.1,0-0.1,0 c0,0,0,0-0.1,0c0,0-0.1,0-0.1,0c0,0,0,0-0.1,0c0,0-0.1,0-0.1,0c0,0,0,0,0,0c-0.1,0-0.1,0-0.2,0c0,0,0,0,0,0 c-0.1,0-0.1,0-0.2,0c0,0,0,0-0.1,0c0,0-0.1,0-0.1,0c0,0,0,0-0.1,0c0,0-0.1,0-0.1,0c0,0,0,0-0.1,0c0,0-0.1,0-0.1,0c0,0,0,0,0,0 c-0.1,0-0.1,0-0.2,0c0,0,0,0,0,0C16.1,2,16,2,16,2c0,0,0,0,0,0c-0.1,0-0.1,0-0.2,0c0,0,0,0,0,0c0,0-0.1,0-0.1,0c0,0,0,0,0,0 c0,0-0.1,0-0.1,0c0,0,0,0,0,0c0,0-0.1,0-0.1,0c0,0,0,0,0,0c0,0,0,0,0,0c0.4-0.1,0.8-0.1,1.2,0.1c1.1,0.4,0.1,1.2-0.4,1.7 c-1,0.9-2.2,1.7-3.3,2.5c-0.9,0.7-1.7,1.3-2.5,1.9c-4.7,3.7-5.9,5.8-5.9,5.8c-2.5,3.6-2.1,6.7-0.9,9.1 c0.7,1.4,1.7,2.6,2.8,3.6c1.3,1.1,2.9,1.8,4.5,2.4c3.1,1.2,6.6,1.5,9.9,0.5c1.6-0.5,3.3-1.2,4.6-2.3c0,0,0.1,0,0.1-0.1 c-1.5,0.9-3.4,1.2-4.6,1.4C20.1,28.9,19.7,28.9,19.7,28.9"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default IconMetavrseLogo;
